import { apiGet, apiPost, apiPut } from '../../_common';

export default {
  create(request) {
    return apiPost('/magenta/ecommerce/product/product-line', request).then(result => result.response);
  },
  update(id, request) {
    return apiPut(`/magenta/ecommerce/product/product-line/${id}`, request).then(result => result.response);
  },
  search(query) {
    return apiGet('/magenta/ecommerce/product/product-line', query).then(result => result.response);
  },
  find(id) {
    return apiGet(`/magenta/ecommerce/product/product-line/${id}`).then(result => result.response);
  },
};
